import {Pipe, PipeTransform} from "@angular/core";
@Pipe({
    name: "field",
    standalone: false
})
export class FieldPipe implements PipeTransform {
    constructor() { }
    transform(value: any, ...args: any[]): any {
        const column: any = args[0];
        let result = value;
        // console.log(column, result);
        column.field.split(".").forEach((f: string) => (result = result[f]));

        return result;
    }
}